import type { ColorValue, ExtrusionStyle, Style } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

export const extrusionStyleNode: NodeDefinition = {
  type: "extrusionStyle",
  label: "Extrusion Style",
  category: "Style",
  inputs: [
    {
      key: "radius",
      label: "radius",
      socket: "number",
      control: { kind: "number", key: "radius", label: "radius", step: 0.1 },
    },
    {
      key: "segments",
      label: "segments",
      socket: "number",
      control: { kind: "number", key: "segments", label: "segments", step: 1 },
    },
    {
      key: "steps",
      label: "steps",
      socket: "number",
      control: { kind: "number", key: "steps", label: "steps", step: 100 },
    },
    { key: "color", label: "Color", socket: "color" },
    { key: "style", label: "Style", socket: "style" },
  ],
  outputs: [{ key: "style", label: "Style", socket: "style" }],
  controls: [],
  defaults: { radius: 2, segments: 36, steps: 0 },

  compute(ctx) {
    const style: ExtrusionStyle = {
      type: "extrusion",
      radius: ctx.number("radius", 2),
      segments: ctx.number("segments", 36),
      steps: ctx.number("steps", 0),
      color: ctx.connected<ColorValue>("color"),
      // A shader plugged in here textures the extruded tube.
      styleInput: ctx.connected<Style>("style"),
    };

    return { style };
  },
};
